import React, { useEffect, useState } from 'react';
import GuideContentRenderer from './GuideContentRenderer';
import { pageContentApi } from '../../lib/api';
import { Skeleton } from '../ui/skeleton';

// Thin, data-driven shell for a Tool/Simulator User Guide. Fetches its content from
// page_contents (admin-editable via /admin/content) and renders it through
// GuideContentRenderer, so wording and structure can be changed without touching code.
const DataDrivenGuidePage = ({ slug }) => {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const data = await pageContentApi.getPageContent(slug);
        setContent(data);
      } catch (err) {
        console.error('Error fetching guide content:', err);
        setError('Failed to load guide');
      } finally {
        setLoading(false);
      }
    };
    fetchContent();
  }, [slug]);

  if (loading) {
    return (
      <div className="min-h-screen px-4 md:px-8 py-16 max-w-screen-2xl mx-auto space-y-4" data-testid="guide-loading">
        <Skeleton className="h-10 w-2/3" />
        <Skeleton className="h-4 w-1/3" />
        <Skeleton className="h-64 w-full mt-8" />
      </div>
    );
  }

  if (error || !content) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-destructive">{error || 'Guide not found'}</p>
      </div>
    );
  }

  return <GuideContentRenderer content={content} />;
};

export default DataDrivenGuidePage;
